import React from 'react';
import classNames from 'classnames';

export interface CKTextFieldProps {
  autoFocus?: boolean;
  className?: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  readOnly?: boolean;
  type?: React.InputHTMLAttributes<HTMLInputElement>['type'];
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: React.InputHTMLAttributes<HTMLInputElement>['disabled'];
  isRequired?: React.InputHTMLAttributes<HTMLInputElement>['required'];
  isReadOnly?: React.InputHTMLAttributes<HTMLInputElement>['readOnly'];
  isSmall?: boolean;
  'aria-label'?: React.AriaAttributes['aria-label'];
  'aria-describedby'?: React.AriaAttributes['aria-describedby'];
  name?: string;
  id?: string;
}

const CKTextField = React.forwardRef(
  (
    {
      autoFocus,
      className,
      id,
      type,
      onChange,
      isReadOnly,
      isDisabled,
      isRequired,
      isSmall,
      placeholder,
      value,
      name,
      ...rest
    }: CKTextFieldProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const inputClass = classNames('ck-field-single', className);

    return (
      <input
        autoFocus={autoFocus}
        id={id}
        ref={ref}
        type={type}
        onChange={onChange}
        readOnly={isReadOnly}
        disabled={isDisabled}
        required={isRequired}
        placeholder={placeholder}
        name={name}
        value={value}
        className={inputClass}
        {...rest}
      />
    );
  }
);

CKTextField.displayName = 'CKTextField';

export default CKTextField;
